import {useEffect, useState} from 'react';
import AgyleDictionaryField from '../ui/selector/agyleDictionaryField';
import PropTypes from 'prop-types';
import {isEmpty} from 'lodash';
import API from '../../app/api';
import config from '../../app/config';
import {useDebounce} from 'use-debounce';

const AddressFinderControl = (props) => {
    const [input, setInput] = useState("");
    const [inputValueDebounced] = useDebounce(input, 1500);
    const [loading, setLoading] = useState(false);

    const [options, setOptions] = useState([]);

    const size = config?.modules?.postCodeFinder?.size || 5;

    useEffect(() => {
        setLoading(true);
    }, [input]);

    const handleSelect = (_e, val) => {
        props.onChange(val);
    };

    const handleInputChange = (e) => {
        setInput(e?.target?.value || "");
    };

    // Search
    useEffect(() => {
        const controller = new AbortController();
        if (!isEmpty(inputValueDebounced) && inputValueDebounced?.length > 2) {
            const opt = {
                resourceUri: "/postCode",
                text: inputValueDebounced,
                pageSize: size,
                options: {},
            };

            API.getSearchList(opt, controller.signal, true).then(res => {
                if (res?.status === 200) {
                    setOptions(res?.data?.collection?.__data || []);
                } else {
                    setOptions([]);
                }
            }).finally(() => {
                setLoading(false);
            });
        } else {
            setOptions([]);
            setLoading(false);
        }
        return () => {
            controller.abort();
        };
    }, [inputValueDebounced]);

    const renderLabel = (opt) => {
        const getVal = (val) => {
            return opt[val] ? `${opt[val]} ` : "";
        };

        return `[${opt?.postcode}] ${getVal("posttown")}${getVal("dependentLocality")}${getVal("doubleDependentLocality")}`
            + `${getVal("thoroughfareAndDescriptor")}${getVal("dependentThoroughfareAndDescriptor")}${getVal("buildingNumber")}`
            + `${getVal("buildingName")}${getVal("subBuildingName")}${opt?.organisationName ? `, ${opt.organisationName}` : ""}`;
    };

    if (!config?.modules?.postCodeFinder?.enabled) return null;

    return (
        <AgyleDictionaryField
            getOptionLabel={renderLabel}
            onChange={handleSelect}
            onInputChange={handleInputChange}
            inputValue={input}
            options={options}
            size={props.size}
            label={props.label}
            noBorder={props?.noBorder}
            disabled={props.disabled}
            withBackground={props.withBackground}
            textFieldStyle={props.textFieldStyle}
            placeholder={props.placeholder}
            style={props.style}
            filterOptions={(options, state) => options}
            isOptionEqualToValue={(option, value) => option.udprn === value.udprn}
            loading={loading}
        />
    );
};

export default AddressFinderControl;

AddressFinderControl.propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    withBackground: PropTypes.bool,
    size: PropTypes.oneOf(["small", "medium", "large"]),
    textFieldStyle: PropTypes.object,
    style: PropTypes.object,
    placeholder: PropTypes.string,
    noBorder: PropTypes.bool,
};

AddressFinderControl.defaultProps = {
    label: "",
    disabled: false,
    size: "small",
    withBackground: true,
    textFieldStyle: null,
    placeholder: "",
    noBorder: false,
};